import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {CoutsEtptService, Dossiers, getListReference, ListReference, PopulationEnum} from '../../../common/services';
import {FondementsJuridiquesService} from '../../../common/services';

import {debounceTime, distinctUntilChanged, finalize, map} from 'rxjs/operators';
import {Pagination} from '@Common/widgets/general/pagination';
import {RemunerationEnum} from '../../../common/services/enums/remunerationEnum';
import {Subscription} from 'rxjs';
import {DarDossiersService} from '../../../common/services/dossiers/dossiers.service';
import {SubSink} from '@Common/core/utils/subsink';
import {EtptModel, EtptsMsModel} from './etpts-ms.model';

/**
 * Section Fondement juridique, N° emploi, coût
 * Le N° d'emploi peut être saisi par MS | SBTCP | DRH, le reste MS | SBTCP
 */
@Component({
  selector: 'app-form-ms-sbtcp',
  templateUrl: './form-ms-sbtcp.component.html',
  styleUrls: ['./form-ms-sbtcp.component.scss']
})
export class FormMsSbtcpComponent implements OnInit, OnChanges, OnDestroy {
  @Input() dossier: Dossiers = null;

  _isInRole = false;
  @Input()
  set isInRole(value) {
    this._isInRole = value;
  }

  get isInRole() {
    return this._isInRole;
  }

  /**
   * Peut-il éditer le N° d'emploi ?
   */
  _canEditEmploi = false;
  @Input() set canEditEmploi(value) {
    this._canEditEmploi = value;
  }

  get canEditEmploi() {
    return this._canEditEmploi;
  }
  @Output() emploiUpdated = new EventEmitter<any>();

  etpt: EtptModel[] = [];
  formFormGroup: UntypedFormGroup;
  fondements: ListReference[];
  remunerationEnum = RemunerationEnum;
  calculateETPTEnCours = false;
  subs: Subscription[] = [];
  subSink = new SubSink();

  constructor(private fondementsSvc: FondementsJuridiquesService,
              private coutsEtptSvc: CoutsEtptService,
              public dossierSvc: DarDossiersService,
              private formBuilder: UntypedFormBuilder) {
    this._initForm();
  }

  ngOnInit() {
    this.initLists();
    console.dir('canEdit =>', this.canEditEmploi);
  }


  private _calculateEtp(dossier: Dossiers) {
    this.calculateETPTEnCours = true;
    this.subSink.sink = this.coutsEtptSvc.calculEtptDossier(dossier)
      .pipe(finalize(() => this.calculateETPTEnCours = false))
      .subscribe((_data: EtptsMsModel) => {
        if (_data && _data.ETPTS && _data.ETPTS.length > 0) {
          this.etpt = _data.ETPTS;
        }
      });
  }
  private _initForm() {
    this.formFormGroup = this.formBuilder.group({
      fondement_juridique: [''],
      plafond_emploi: [''],
      numero_emploi: [''],
      decompte: [''],
      cout_estime: [],
      inm: [],
    });
    this.formFormGroup.controls['decompte'].disable();

    this.subs.push(this.formFormGroup.valueChanges
        .pipe(debounceTime(400), distinctUntilChanged())
        .subscribe((data) => {
          const data_emit = {
            inm: data.inm,
            cout_estime: data.cout_estime,
            fondement_juridique: data.fondement_juridique,
            plafond_emploi: data.plafond_emploi,
            numero_emploi: data.numero_emploi,
            canEditEmploi: this._canEditEmploi // pour effet de bord disable et valeur des champs sur les patchValue
          };

          this.emploiUpdated.emit(data_emit);
      }));
  }

  private async initLists() {
    const population = this.dossier.type_demande || PopulationEnum.aucun
    this.fondements = await getListReference(this.fondementsSvc, population, { id: null, label: ''});
  }

  private async initFondements() {
    const addFirstItem: ListReference = {id: null, label: ''};
    const extraParams: Map<string, string> = new Map<string, string>();
    return await this.fondementsSvc
      .listAllItems(extraParams, '', false)
      .pipe(map((data: Pagination) => {
        return [addFirstItem, ...data.list];
      }))
      .toPromise();
  }

  private _setDecompte(dossier: Dossiers) {
    if (dossier.duree && dossier.quotite && dossier.quotite > 0) {
      this.formFormGroup.patchValue({decompte: dossier.decompte_plafond});
    }
  }

  private _setValuesForm(dossier: Dossiers) {
    this.formFormGroup.patchValue({fondement_juridique: dossier.fondement_juridique});
    this.formFormGroup.patchValue({plafond_emploi: dossier.plafond_emploi});
    this.formFormGroup.patchValue({numero_emploi: dossier.numero_emploi});
    this.formFormGroup.patchValue({cout_estime: dossier.cout_estime});
    this.formFormGroup.patchValue({inm: dossier.inm});


    this._setDecompte(dossier);
  }

  private _switchNumeroCout(canEdit) {
    console.log('** canEditEmploi component');

    if (canEdit) {
      setTimeout(() => {
        this.formFormGroup.controls['numero_emploi'].enable();
      });

      setTimeout(() => {
        this.formFormGroup.controls['cout_estime'].enable();
      });

      setTimeout(() => {
        this.formFormGroup.controls['inm'].enable();
      });
    } else {
      setTimeout(() => {
        this.formFormGroup.controls['numero_emploi'].disable();
      });

      setTimeout(() => {
        this.formFormGroup.controls['cout_estime'].disable();
      });

      setTimeout(() => {
        this.formFormGroup.controls['inm'].disable();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
     if (changes.isInRole && changes.isInRole.isFirstChange() && changes.isInRole.currentValue !== null &&
         changes.canEditEmploi && changes.canEditEmploi.isFirstChange() && changes.canEditEmploi.currentValue !== null) {
        if (! this._isInRole) {
          setTimeout(() => this.formFormGroup.disable());
        }

        this._switchNumeroCout(changes.canEditEmploi.currentValue);
    }

    if (changes.dossier && changes.dossier.currentValue !== null) {
      this._setValuesForm(changes.dossier.currentValue);
      this._calculateEtp(changes.dossier.currentValue);
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(_sub => _sub.unsubscribe());
    this.subSink.unsubscribe();
  }

  onFondementJuridiqueChange() {
    const fondement_id = this.formFormGroup.controls['fondement_juridique'].value;
    const fondement = this.fondements.find((_fondement => _fondement.id === fondement_id));
    const txt = fondement?.numero_emploi || '';
    if (txt.trim() !== '') {
      this.formFormGroup.patchValue({numero_emploi: txt});
    }
  }
}
